// @ts-nocheck
import { SubscribeToListApiParameter } from "@insite/client-framework/Services/EmailService";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import {
    chain,
    ExecuteOnSuccessCallback as baseExecuteOnSuccessCallback,
    SubscribeParameter,
} from "@insite/client-framework/Store/CommonHandlers/Subscribe";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import ga from "@toolkit/Framework/Common/GoogleAnalytics";
import {
    ApiHandlerDiscreteParameter,
    markSkipOnCompleteIfOnSuccessIsSet,
    replaceInChain,
} from "@toolkit/Modules/client-framework/HandlerCreator";

type HandlerType = ApiHandlerDiscreteParameter<SubscribeParameter, SubscribeToListApiParameter>;

export const ExecuteOnSuccessCallback: HandlerType = props => {
    const userRoles = getSession(props.getState()).userRoles;

    props.parameter.onSuccess?.();

    /* Store Custom Code - Start */
    if (userRoles && userRoles.includes("Veterinarian")) {
        ga.push({
            event: "subscribe_newsletter_vet",
            authentication_method: "email",
            subscribe_newsletter_vet_email_address: props.apiParameter.emailAddress,
        });
    } else {
        ga.push({
            event: "subscribe_newsletter",
            authentication_method: "email",
            subscribe_newsletter_email_address: props.apiParameter.emailAddress,
        });
    }
    /* Store Custom Code - End */
};

replaceInChain(chain, baseExecuteOnSuccessCallback, ExecuteOnSuccessCallback);
